import React, { useEffect, useState } from 'react'

// MUI imports
import Collapse from '@mui/material/Collapse'
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Icon } from '@iconify/react/dist/iconify.js';
import StyledVerticalNavExpandIcon from '../../../../component/icon/StyledVerticalNavExpandIcon';
import ChevronRight from '../../../../component/icon/ChevronRight';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';

function SubMenu({ title, icon, children, isOpen, version, isDrawerOpen }) {

    // States
    const [open, setOpen] = useState(isOpen);
    const [active, setActive] = useState(false);

    // Hooks
    let location = useLocation();

    useEffect(() => {
        if (children && children.length > 0) {
            let exist = false
            children.map((child) => {
                if (child?.props?.href == location.pathname) {
                    exist = true
                }
            })
            setActive(exist)
        }
    }, [location.pathname])

    useEffect(() => {
        if (version > 0) {
            setOpen(false);
        }
    }, [version])

    useEffect(() => {
        if (!isDrawerOpen) {
            setOpen(false)
        }
    }, [isDrawerOpen])

    return (
        <div>
            <ListItemButton
                className={classnames(
                    '!rounded-sm',
                    {
                        '!bg-actionFocus': active
                    }
                )}
                onClick={() => setOpen(!open)}>
                <ListItemIcon>
                    <Icon className="text-textPrimary" icon={icon} style={{ fontSize: '24px' }} />
                </ListItemIcon>
                {isDrawerOpen && (
                    <>
                        <span className='text-textPrimary text-[15px] w-full pt-1 ml-1'>{title}</span>
                        <StyledVerticalNavExpandIcon open={open} transitionDuration={200}>
                            <ChevronRight fontSize='1.5rem' />
                        </StyledVerticalNavExpandIcon>
                    </>
                )}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </div>
    )
}

export default SubMenu